import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import { useSignal } from "@preact/signals";
import { Dialog } from "../Dialog";
import Wheel from "./Wheel";
import { WheelInputProps } from "./interfaces";

const SEPARATOR = "_._";

const WheelInput: FC<WheelInputProps> = ({
    show,
    wheels,
    value,
    valueSignal,
    onChange,
    renderLabel = (value) => value.join(", "),
    transform,
}) => {
    const values = useSignal(value ?? []);
    const finalValues = valueSignal ?? values;

    useEffect(() => {
        if (!valueSignal) {
            // manual mode
            return;
        }

        const oldValue = values.peek();
        const changed = oldValue.some((v, idx) => v !== value[idx]);

        if (changed) {
            values.value = value;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleSelect = () => {
        const newValue = finalValues.peek();
        const changed = newValue.some((v, idx) => v !== value[idx]);

        if (changed) {
            onChange(newValue);
        }

        show.value = false;
    };

    return (
        <Dialog show={show}>
            <div className="w-[calc(100vw-40px)] rounded-2xl bg-white pt-4 text-xl shadow-lg border border-gray-200">
                <div className="flex h-[300px] w-full text-center">
                    {wheels.map((wheel, idx) => (
                        <Wheel
                            key={idx}
                            wheel={wheel}
                            values={finalValues}
                            index={idx}
                            onChange={(value) => {
                                const newValues = finalValues.peek().slice();

                                newValues[idx] = value;

                                if (
                                    finalValues.peek().join(SEPARATOR) !==
                                    newValues.join(SEPARATOR)
                                ) {
                                    const transformed = transform
                                        ? transform(newValues)
                                        : newValues;

                                    finalValues.value = transformed;
                                }
                            }}
                        />
                    ))}
                </div>
                <div className="mt-4 flex justify-end p-4">
                    <button
                        type="button"
                        className="block rounded-full bg-sky-600 px-8 py-2 text-white"
                        onClick={handleSelect}
                    >
                        Select {renderLabel(finalValues.value)}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default WheelInput;
